/*
 * @Descripttion: 工程配置文件
 * @Author: linwc
 * @Date: 2025-08-27 10:40:36
 * @LastEditors: linwc
 * @LastEditTime: 2025-11-21 15:57:38
 */

import store from '@/store';

/**
 * 获取谷歌地图 API Key
 *
 * lysora 测试环境返回测试 key
 * lysora 正式环境返回正式 key
 * 其他环境返回通用 key
 *
 * 依赖全局变量 __APP_BRAND__ 和 __PRODUCTION__
 *
 * @returns {string} 谷歌地图 API Key
 */
export function getGoogleMapKey() {
  // 本地调试用下面的 key
  // return 'AIzaSyAceD2H4QwWi_Qhnuc6MTgqEtTtRWQw9d8';
  return process.env.VUE_APP_GOOGLE_KEY;
}

/**
 * @name: linwc
 * @msg: 项目图片资源
 * @return {*}
 */
export function getProjectImages() {
  let _images = {};
  if (__APP_BRAND__ === 'lysora') {
    _images = {
      ...require('./lysora/images').default
    };
  } else {
    _images = {
      ...require('./reyee/images').default
    };
  }
  return _images;
}

/**
 * @name: linwc
 * @msg: 按需导入项目样式变量
 * @return {*}
 */
export function importProjectStyles() {
  if (__APP_BRAND__ === 'lysora') {
    require('./lysora/styles/index.css');
  } else {
    require('./reyee/styles/index.css');
  }
}

/**
 * @name: linwc
 * @msg: 获取模板图映射配置
 * 根据不同品牌返回对应的模板图配置
 * lysora 和其他品牌使用不同的模板图资源
 *
 * @returns {Object} 模板图映射对象
 */
export function getTemplateImageMap() {
  if (__APP_BRAND__ === 'lysora') {
    if (!__PRODUCTION__) {
      // lysora 测试环境
      return 'https://intl-1301408934.cos.ap-singapore.myqcloud.com/prod/guide/moban.jpg';
    } else {
      // lysora 正式环境
      return 'https://intl-1301408934.cos.ap-singapore.myqcloud.com/prod/guide/moban.jpg';
    }
  } else {
    // 其他环境
    let url = 'https://schemes-1301408934.cos.ap-nanjing.myqcloud.com/prod/guide/moban.jpg'; // 国内
    const enetUrl = {
      'https://demotest.rj.link': 'https://intl-1301408934.cos.ap-singapore.myqcloud.com/prod/guide/moban.jpg', //海外测试
      'https://cloud-ap.ruijienetworks.com':
        'https://intl-1301408934.cos.ap-singapore.myqcloud.com/prod/guide/moban.jpg', //海外测试
      'https://cloud-as.ruijienetworks.com':
        'https://intl-1301408934.cos.ap-singapore.myqcloud.com/prod/guide/moban.jpg', //海外生产（亚洲云）
      'https://cloud-eu.ruijienetworks.com':
        'https://intl-eu-1301408934.cos.eu-frankfurt.myqcloud.com/prod/guide/moban.jpg', //海外生产（欧洲云）
      'https://cloud-me.ruijienetworks.com':
        'https://intl-eu-1301408934.cos.eu-frankfurt.myqcloud.com/prod/guide/moban.jpg', //海外生产（欧洲云）
      'https://cloud-a1.ruijienetworks.com':
        'https://intl-eu-1301408934.cos.eu-frankfurt.myqcloud.com/prod/guide/moban.jpg', //海外生产（欧洲云）
      'https://cloud-la.ruijienetworks.com':
        'https://intl-eu-1301408934.cos.eu-frankfurt.myqcloud.com/prod/guide/moban.jpg', //海外生产（欧洲云）
      'https://cloud-us.ruijienetworks.com':
        'https://intl-us-1301408934.cos.na-ashburn.myqcloud.com/prod/guide/moban.jpg', //海外生产（美洲云）
      'https://cloud-uk.ruijienetworks.com':
        'https://intl-eu-1301408934.cos.eu-frankfurt.myqcloud.com/prod/guide/moban.jpg' //海外生产（欧洲云）
    };
    const curOrigin = window.location.origin;

    return enetUrl[curOrigin] || url;
  }
}

/**
 * @name: linwc
 * @msg: 控制某些功能是否开启
 * @param {string} featureName 功能名称
 * @returns {boolean} 是否开启
 */
export function isFeatureEnabled(featureName) {
  // 获取 userInfo
  const userInfo = store.state.User.userInfo;
  const featureConfig = {
    nps: __APP_BRAND__ !== 'lysora', // 例：lysora不开启nps
    // 你可以继续添加其他功能控制
    deepEmulation: __APP_BRAND__ === 'lysora' ? true : userInfo.theme === 'REYEE_PRO'
  };
  return !!featureConfig[featureName];
}

/**
 * @name: linwc
 * @msg: getModuleConfig,根据模块名称获取对应的模块配置。可根据不同环境、品牌等扩展配置内容。
 * @param {string} moduleName 模块名称，如 'intlDownload'
 * @return {object} 返回对应模块的配置对象
 */
export function getModuleConfig(moduleName) {
  const moduleConfig = {
    // 你可以继续添加其他模块的配置
  };
  return moduleConfig[moduleName];
}
